export default __webpack_public_path__ + "static/media/Shop-2.0b10e287.webp";